var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SYSTEM_ROLES } from "@/app/components/constants";
import { STORE } from "@/store";
import { computed, toJS, makeObservable } from "mobx";
import { Duration } from "luxon";
export class SelectedInteractionStore {
    constructor() {
        makeObservable(this);
    }
    get isActiveTask() {
        var _a, _b;
        if (STORE.interactions.selectedInteraction && STORE.agentContact.taskSelected) {
            return ((_a = STORE.interactions.selectedInteraction) === null || _a === void 0 ? void 0 : _a.id) === ((_b = STORE.agentContact.taskSelected) === null || _b === void 0 ? void 0 : _b.interactionId);
        }
        return false;
    }
    get epDnMapping() {
        if (this.isActiveTask) {
            return STORE.agent.getEpDnMapping;
        }
        // TODO: Is this good enough?
        return {
            initialFetchCompleted: false,
            data: [],
            errorObj: null
        };
    }
    get addressBook() {
        if (this.isActiveTask) {
            return STORE.agent.getAddressBook;
        }
        // TODO: Is this good enough?
        return {
            initialFetchCompleted: false,
            data: [],
            errorObj: null
        };
    }
    get interaction() {
        if (this.isActiveTask) {
            return STORE.agentContact.taskSelected;
        }
        const interaction = STORE.interactions.selectedInteraction;
        if (interaction) {
            const customerName = this.getCustomerName(interaction.customer);
            const customerNumber = this.getCustomerNumber(interaction.customer, customerName);
            return {
                customerName,
                mediaType: interaction.channelType,
                mediaChannel: interaction.channelSubType,
                isWrapUp: false,
                queueId: interaction.lastQueue.id,
                ani: customerNumber,
                displayAni: customerNumber,
                destAgentName: interaction.lastAgent.name,
                destAgentPhoneNumber: interaction.lastAgent.phoneNumber,
                destAgentType: undefined,
                agentId: interaction.lastAgent.id,
                consultHold: false,
                consultMediaResourceId: "",
                owner: interaction.lastAgent.id,
                ownerName: interaction.lastAgent.name,
                ownerPhoneNumber: interaction.lastAgent.phoneNumber,
                orgId: "",
                interactionId: interaction.id,
                reasonCode: undefined,
                destAgentId: interaction.lastAgent.id,
                mediaResourceId: "",
                isConsulted: false,
                isFcManaged: false,
                state: interaction.status,
                isTerminated: !interaction.isActive,
                timeStamp: interaction.lastActivityTime,
                consultTimeStamp: null,
                wrapUpTimestamp: null,
                wrapUpAssistTimestamp: null,
                holdTimestamp: null,
                consultHoldTimestamp: null,
                hasJoined: false,
                isOffered: undefined,
                ronaTimeout: "",
                virtualTeamName: interaction.lastTeam.name,
                ivrPath: "",
                phoneNumber: customerNumber,
                pathId: "",
                dnis: customerNumber,
                category: "",
                additionalDetails: "",
                sourceNumber: interaction.origin,
                sourcePage: "",
                appUser: interaction.lastAgent.signInId,
                customerNumber,
                isConferencing: false,
                isRecorded: undefined,
                isRecordingPaused: undefined,
                isPauseResumeEnabled: undefined,
                recordingPauseDuration: undefined,
                contactDirection: interaction.direction,
                outboundType: undefined,
                isHold: false,
                ctqInProgress: false,
                outdialTransferToQueueEnabled: undefined,
                callAssociatedData: undefined,
                hasCustomerLeft: undefined,
                isConvNotFound: undefined,
                updatedBy: interaction.lastAgent.id,
                parentInteractionId: undefined,
                childInteractionId: undefined,
                relationshipType: undefined,
                parent_ANI: undefined,
                parent_DNIS: undefined,
                isOwner: false,
                EpDnConsultDestinationAgentJoined: false,
                isSecondaryEpDnAgent: false,
                contactPhoneNumber: interaction.origin,
                contactQueue: interaction.lastQueue.name,
                participants: undefined,
                activeParticipants: undefined,
                consultedParticipant: undefined,
                contactStatus: interaction.status,
                timeInContactStatus: undefined,
                totalContactDuration: Duration.fromMillis(interaction.totalDuration).toFormat("hh:mm:ss"),
                agentInteractionTime: undefined,
                recording: undefined,
                monitoringStartTime: undefined,
                type: interaction.channelType,
                isMonitoringOnHold: undefined,
                monitoringHoldTimer: undefined,
                monitoringOwnerName: undefined,
                isCallMute: undefined,
                isBargedIn: undefined,
                bargedInTimeStamp: undefined,
                fcDesktopViewCad: undefined,
                primaryMediaParticipants: {},
                isConsultEnabledForMPC: false,
                isConsultInProgress: false,
                isConferenceInProgress: false,
                isWrapUpAssist: false,
                isSecondaryAgentCBT: false,
                postCallTimestamp: null,
                isInteractionInPostCall: false,
                isAmdDetectedInCallback: false,
                isCompleted: !interaction.isActive
            };
        }
        return null;
    }
    get isCallMuted() {
        if (this.isActiveTask) {
            return STORE.agentContact.isCallMuted;
        }
        // TODO: Is this good enough?
        return undefined;
    }
    get agentConfig() {
        var _a, _b, _c;
        return {
            agentDBId: STORE.agent.agentDbId,
            channels: STORE.agent.channels,
            agentProfileID: STORE.agent.agentProfileID,
            isendcallenabled: STORE.agent.isEndCallEnabled,
            isEndConsultEnabled: STORE.agent.isEndConsultEnabled,
            privacyShieldVisible: (_a = STORE.agent.privacyShieldVisible) !== null && _a !== void 0 ? _a : false,
            agentId: STORE.agent.agentId,
            callVariablesSuppressed: toJS(STORE.agent.callVariablesSuppressed),
            cadVariables: toJS(STORE.agent.cadVariables),
            allowConsultToQueue: STORE.agent.allowConsultToQueue,
            deviceType: STORE.agent.deviceType,
            dtmfValue: STORE.agent.dtmfValue,
            isWebRTCEnabled: (STORE.app.featureFlags.isWebRTCEnabled && STORE.agent.role === SYSTEM_ROLES.AGENT) ||
                (STORE.app.featureFlags.isWebRTCEnabled &&
                    STORE.app.featureFlags.isWebRTCSupervisorEnabled &&
                    STORE.agent.role === SYSTEM_ROLES.SUPERVISOR),
            isIMIGlobalVariablesEnabled: STORE.app.featureFlags.isIMIGlobalVariablesEnabled &&
                ((_c = (_b = STORE.agentContact.getMediaMgrFromTask()) === null || _b === void 0 ? void 0 : _b.includes("digitalmm")) !== null && _c !== void 0 ? _c : false),
            isGlobalVariablesEnabled: STORE.app.featureFlags.isGlobalVariablesEnabled,
            role: STORE.agent.userSelectedRole,
            isBargeInEnabled: STORE.agent.isBargeInEnabled,
            agentCallMonitoringState: STORE.agentContact.getAgentCallMonitoringStateDetails,
            microsoftAuthConfig: STORE.auth.getMicrosoftAuthConfig,
            collaborationConfig: STORE.agent.collaboration,
            isWebrtcEndCallEnabled: STORE.app.featureFlags.isWebrtcEndCallEnabled,
            isWxccMultiPartyConfEnabled: STORE.app.featureFlags.isWxccMultiPartyConfEnabled,
            isWxccPersistCallEnabled: STORE.app.featureFlags.isWxccPersistCallEnabled,
            isAllowConfTransferToEpDnEnabled: STORE.app.featureFlags.isAllowConfTransferToEpDnEnabled,
            isInteractionBtnConfirmDialogEnabled: STORE.app.isInteractionBtnConfirmDialogEnabled,
            isConsultTransferInfiniteScrollEnabled: STORE.app.featureFlags.isConsultTransferInfiniteScrollEnabled,
            isSecureCADVariablesEnabled: STORE.app.featureFlags.isSecureCADVariablesEnabled,
            webexCallingCallId: STORE.agentContact.getWebexCallingCallId,
            isWxccPersistConsultEnabled: STORE.app.featureFlags.isWxccPersistConsultEnabled,
            isConferenceTransferEnabled: STORE.app.featureFlags.isConferenceTransferEnabled
        };
    }
    get cadStatus() {
        if (this.isActiveTask) {
            return {
                isInteractionCADContainersExpanded: STORE.agentContact.getCADSectionOpenStatus,
                isMainContainerCADExpanded: STORE.agentContact.getMainCadSectionStatus,
                isConsultContainerCADExpanded: STORE.agentContact.getConsultCadSectionStatus
            };
        }
        // TODO: Is this good enough?
        return {
            isInteractionCADContainersExpanded: false,
            isMainContainerCADExpanded: false,
            isConsultContainerCADExpanded: false
        };
    }
    get wrapUpData() {
        var _a, _b;
        if (this.isActiveTask) {
            return STORE.agent.wrapUpData;
        }
        // TODO: Is this good enough?
        return {
            wrapUpProps: {
                autoWrapup: undefined,
                autoWrapupInterval: undefined,
                lastAgentRoute: undefined,
                wrapUpReasonList: [],
                wrapUpCodesList: undefined,
                idleCodesAccess: undefined,
                interactionId: (_b = (_a = STORE.interactions.selectedInteraction) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
                allowCancelAutoWrapup: undefined
            }
        };
    }
    get agentWrapUpCodeProps() {
        if (this.isActiveTask) {
            return STORE.agent.getAgentWrapUpCodeProps;
        }
        // TODO: Is this good enough?
        return {};
    }
    get callpersistence() {
        if (this.isActiveTask) {
            return { isOpen: STORE.agentContact.callPersistence };
        }
        // TODO: Is this good enough?
        return { isOpen: false };
    }
    get isVoiceInteraction() {
        if (this.isActiveTask) {
            return STORE.agentContact.isTelephoneOrMidcall;
        }
        // TODO: Is this good enough?
        return false;
    }
    getCustomerName(customer) {
        if (customer === null || customer === void 0 ? void 0 : customer.name) {
            return customer.name;
        }
        if (customer === null || customer === void 0 ? void 0 : customer.phoneNumber) {
            return customer.phoneNumber;
        }
        if (customer === null || customer === void 0 ? void 0 : customer.email) {
            return customer.email;
        }
        return "";
    }
    getCustomerNumber(customer, customerName) {
        if (customer === null || customer === void 0 ? void 0 : customer.phoneNumber) {
            return customer.phoneNumber;
        }
        if (customer === null || customer === void 0 ? void 0 : customer.email) {
            return customer.email;
        }
        return customerName;
    }
}
__decorate([
    computed
], SelectedInteractionStore.prototype, "isActiveTask", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "epDnMapping", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "addressBook", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "interaction", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "isCallMuted", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "agentConfig", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "cadStatus", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "wrapUpData", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "agentWrapUpCodeProps", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "callpersistence", null);
__decorate([
    computed
], SelectedInteractionStore.prototype, "isVoiceInteraction", null);
